export default {
    SET_UPLOADED_FILES (state, uploadedFiles) {
      state.uploadedFiles = uploadedFiles
    },
    SET_CLIENT_DOWNLOAD_FILES (state, clientDownloadFiles) {
      state.clientDownloadFiles = clientDownloadFiles
    }
  }
